import { company } from '../data/company';

/**
 * Sends a form submission to the store inbox through FormSubmit (formsubmit.co).
 * No backend needed. The FIRST submission triggers a one-time activation email
 * to `company.formsEmail` — click "Activate" in that email and every later
 * submission is delivered automatically.
 */
export async function sendFormEmail(
  subject: string,
  fields: Record<string, string | number | undefined>,
  options: { replyTo?: string; file?: File | null } = {},
): Promise<void> {
  const data = new FormData();
  data.append('_subject', subject);
  data.append('_template', 'table');
  data.append('_captcha', 'false');
  if (options.replyTo) data.append('_replyto', options.replyTo);
  Object.entries(fields).forEach(([k, v]) => {
    if (v !== undefined && v !== '') data.append(k, String(v));
  });
  if (options.file) data.append('attachment', options.file);
  data.append('Sent from', window.location.href);

  const res = await fetch(`https://formsubmit.co/ajax/${company.formsEmail}`, {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: data,
  });
  if (!res.ok) throw new Error(`Form delivery failed (${res.status})`);
  const json = (await res.json().catch(() => ({}))) as { success?: string | boolean };
  if (json.success === false || json.success === 'false') throw new Error('Form delivery failed');
}
